import { Button, Icon, Row } from "_core/components/common/UI";
// styles imports
import './FileDownLoadButton.scss';

const FileDownLoadButton = (props) => {

    // コンポーネントの返却
	return (
    <a className={"file-download-button " + (props.className ? props.className : "")} href={props.publicPath} download={props.downLoadName}>
        <Button className={"padding-16px " + (props.buttonClass ? props.buttonClass : "")}>
            {props.children}
        </Button>
    </a>
	);
}
export default FileDownLoadButton
